import {StempelResponseModel} from "../../../services/api/stempel/stempelResponseModel";
import {dateTimeStringFromApiToDate} from "../../../index";

export class StempelModel {
    id: string;
    navn: string;
    rolleTitel: string;
    initialer: string;
    authorisationsId?: string;
    dato: Date;

    static FromResponseModel(responseModel: StempelResponseModel): StempelModel {
        const model = new StempelModel();
        model.id = responseModel.id;
        model.navn = responseModel.navn;
        model.rolleTitel = responseModel.rolleTitel;
        model.initialer = responseModel.initialer;
        model.authorisationsId = responseModel.authorisationsId;
        model.dato = dateTimeStringFromApiToDate(responseModel.dato);
        return model;
    }
}
